import useHistoricBondCreateBase from "./useHistoricBondCreateBase";
import { TRUSTEE_HISTORIC_CREATE_CONFIG } from "./historicBondCreateConfig";

function useTrusteeBondCreateHistoric() {
  const {
    isLoading,
    errors,
    setErrors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    globalState,
    updateGlobalState,
    handleSubmit,
    handleSupportRequestSubmit,
  } = useHistoricBondCreateBase(TRUSTEE_HISTORIC_CREATE_CONFIG);

  return {
    isLoading,
    errors,
    setErrors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    globalState,
    updateGlobalState,
    handleSubmit,
    handleSupportRequestSubmit,
  };
}

export default useTrusteeBondCreateHistoric;
